module.exports = __webpack_public_path__ + "static/media/mobile-burger.2f341c8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/imgs/mobile-burger.svg
// module id = 902
// module chunks = 0